import { Center, Grid, SegmentedControl } from '@mantine/core';
import { useEffect, useState } from 'react';
import Spinner from '../Spinner';
import ActivateDomainSubscriptionCard from './ActivateDomainSubscriptionCard';

const SubscriptionSelectorForm = ({ selectedSubscriptions, setSelectedSubscriptions, subscriptions, suggestType }) => {
  const [type, setType] = useState(suggestType || selectedSubscriptions[0]?.type || 'flagship');

  const getLowestPossiblePrice = (type) => {
    const subscriptionsForType = subscriptions.filter(
      (s) => s.subscriptionTieredPricings?.length > 0 && s.type === type
    );

    if (subscriptionsForType.length > 0) {
      // TODO: this will not work if different subscriptions have different currencies
      const currency = subscriptionsForType[0].currency;

      return {
        price: Math.min(
          ...subscriptionsForType.flatMap((subscription) => subscription.subscriptionTieredPricings.map((p) => p.price))
        ),
        currency,
      };
    }
  };

  useEffect(() => {
    if (selectedSubscriptions.find((s) => s.type !== type)) {
      setSelectedSubscriptions(selectedSubscriptions.filter((s) => s.type === type));
    }
  }, [selectedSubscriptions, setSelectedSubscriptions, type]);

  const toggleSelected = (subscription) => {
    if (type === 'flagship') {
      return setSelectedSubscriptions([subscription]);
    }

    if (selectedSubscriptions.map((s) => s.id).includes(subscription.id)) {
      setSelectedSubscriptions(selectedSubscriptions.filter((s) => s.id !== subscription.id));
    } else {
      setSelectedSubscriptions([...selectedSubscriptions, subscription]);
    }
  };

  if (!subscriptions) {
    return <Spinner />;
  }

  const subscriptionsElements = subscriptions
    .filter((s) => s.type === type)
    .map((subscription) => (
      <ActivateDomainSubscriptionCard
        key={subscription.id}
        subscription={subscription}
        isSelected={selectedSubscriptions.map((s) => s.id).includes(subscription.id)}
        toggleSelected={toggleSelected}
      />
    ));

  const lowestPriceFlagship = getLowestPossiblePrice('flagship');
  const lowestPriceModular = getLowestPossiblePrice('modular');

  const options = [];

  if (lowestPriceFlagship) {
    options.push({
      label: `Releva Pro (best value - starting at ${lowestPriceFlagship.price.toLocaleString('en-US', {
        style: 'currency',
        currency: lowestPriceFlagship?.currency,
      })})`,
      value: 'flagship',
    });
  }

  if (lowestPriceModular) {
    options.push({
      label: `Releva Lite (lowest price - starting at ${lowestPriceModular.price.toLocaleString('en-US', {
        style: 'currency',
        currency: lowestPriceModular.currency,
      })})`,
      value: 'modular',
    });
  }

  return (
    <>
      <Grid py="md">
        <Grid.Col span={12}>
          {!suggestType && (
            <Center>
              <SegmentedControl value={type ?? ''} onChange={(type) => setType(type)} data={options} />
            </Center>
          )}
        </Grid.Col>
      </Grid>
      <Grid>{subscriptionsElements}</Grid>
    </>
  );
};

export default SubscriptionSelectorForm;
